import React from "react";
import Lottie from "react-lottie";

const LottieAnimation = ({ animationData, width, height }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="overflow-hidden rounded-t-[24px]" style={{ width, height }}>
      <Lottie options={defaultOptions} width={width} height={height} />
    </div>
  );
};

export default LottieAnimation;
